export default __webpack_public_path__ + "static/media/22-min.bf7cd21c.jpg";